export interface DrugTest {
	drugTestId: number;
	channel: string;
	brand: string;
	vendor: string;
	representativeId: number;
	representativeLogin: string;
	representativeName: string;
	conductedOn: Date;
	providerName: string;
	specimenId: string;
	result: string;
}

export enum DrugTestResultEnum {
	Negative = 0,
	Positive = 1,
	Inconclusive = 2,
	Refusal = 3,
	Adulterated = 4,
	Diluted = 5,
}
